<div class="admin" [ngClass]="isExpanded? 'admin-expanded':''">
    <div class="logo-container">
        <button class="logo" (click)="toggleCollapse()"><i class="material-icons">menu</i></button>
        <div class="logo-text" *ngIf="isExpanded"> Vendor Registration</div>
        <button class="btn-close"></button>
        <!-- <i class="fal fa-times close-icon"(click)="closeSidenav()"></i> -->
    </div>
    <div *ngIf="loading" class="overlay">
        <div class="spinner"></div>
    </div>

    <ul class="admin-nav">
        <ng-container *ngFor="let data of navbarData">
            <li
              class="admin-nav-item"
              *ngIf="data.allowedUserTypes.includes(userType)"
              [class.messages-nav-pulse]="data.routeLink === '/messages' && unreadVendorMessages"
            >
                <a class="admin-nav-link" [routerLink]="[data.routeLink]" routerLinkActive="active">
                  
                  <!-- Font Awesome icons -->
                  <i *ngIf="data.icon" class="admin-nav-link-icon" [class]="data.icon"></i>
              
                  <!-- Material Icons -->
                  <!-- <i *ngIf="data.iconClass === 'material-icons'" 
                     class="admin-nav-link-icon material-icons">
                     {{ data.iconName }}
                  </i> -->
              
                  <span class="admin-nav-link-text" *ngIf="isExpanded">{{ data.Label }}</span>
                </a>
            </li>
              
        <a href="#" class="admin-nav-link fixed-bottom" [routerLink]="[logout.routeLink]" routeLinkActive="active" (click)="handleLogout($event)">
            <i class="admin-nav-link-icon" [class]="logout.icon"></i>
            <span class="admin-nav-link-text" *ngIf="isExpanded">{{logout.Label}}</span>
        </a>
    </ng-container>
    </ul>
    

</div>